var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from "react";
import flowplayer from "@flowplayer/player";
const Flowplayer = React.forwardRef((opts, forwardedRef) => {
    const ref = forwardedRef === null ? useRef(null) : forwardedRef;
    const { token, src } = opts, rest = __rest(opts
    // Init Flowplayer on mount
    , ["token", "src"]);
    // Init Flowplayer on mount
    useEffect(() => {
        if (typeof ref === "function")
            return;
        if (!ref)
            return;
        if (!ref.current)
            return;
        if (!token)
            return;
        const api = flowplayer(ref.current, Object.assign({ token }, opts));
        return () => {
            api.destroy();
            if (ref.current)
                ref.current.innerHTML = "";
        };
    }, [token, ref]);
    const useApi = () => ref && typeof ref !== "function" && ref.current ? flowplayer(ref.current) : null;
    useEffect(() => {
        const api = useApi();
        if (!api)
            return;
        api.setOpts(rest);
    }, [opts]);
    useEffect(() => {
        const api = useApi();
        if (!api || !src)
            return;
        api.setSrc(src);
    }, [src]);
    return React.createElement("div", { ref: ref });
});
export default Flowplayer;
